import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Links from './Links';
import ClientProvider from './client';
export default createDemo(import.meta.url, Links, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/links/demos/links/Links.tsx",
    "fileName": "Links.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Link from '@mui/material/Link';\n\nconst preventDefault = (event: React.SyntheticEvent) => event.preventDefault();\n\nexport default function Links() {\n  return (\n    <Box\n      sx={{\n        typography: 'body1',\n        '& > :not(style) ~ :not(style)': {\n          ml: 2,\n        },\n      }}\n      onClick={preventDefault}\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Link href=\"#\">Link</Link>\n      <Link href=\"#\" color=\"inherit\">\n        {'color=\"inherit\"'}\n      </Link>\n      <Link href=\"#\" variant=\"body2\">\n        {'variant=\"body2\"'}\n      </Link>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 27,
        "focusedLines": 7,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Link from '@mui/material/Link';\n\nconst preventDefault = (event: React.SyntheticEvent) => event.preventDefault();\n\nexport default function Links() {\n  return (\n    <Box\n      sx={{\n        typography: 'body1',\n        '& > :not(style) ~ :not(style)': {\n          ml: 2,\n        },\n      }}\n      onClick={preventDefault}\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Link href=\"#\">Link</Link>\n      <Link href=\"#\" color=\"inherit\">\n        {'color=\"inherit\"'}\n      </Link>\n      <Link href=\"#\" variant=\"body2\">\n        {'variant=\"body2\"'}\n      </Link>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "href"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "#",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">Link</",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "href"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "#",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "inherit",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "color=\"inherit\"",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "href"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "#",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "body2",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "variant=\"body2\"",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 27,
    "focusedLines": 7,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Link"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
